import createCrudVuexModule from "@/store/crud";

export const question = createCrudVuexModule({
  namespaced: true,
  path: "/library/question",
});
export const questionSet = createCrudVuexModule({
  namespaced: true,
  path: "/library/question-set",
});

export const workspaceQuestionSet = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/question-set",
});
export const managementQuestionSet = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/question-set",
});

export const workspaceQuestion = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/question",
  actions: {
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
      commit("reset");
    },
  },
});

export const managementQuestion = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/question",

  actions: {
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
      commit("reset");
    },
  },
});
